module.exports = __webpack_public_path__ + "static/bluemuslinrompermain-2e6be0a3ad19bbb1ff7171562a3225f1.jpeg";